import { LogLevel } from '../constants/app.constant';

import { ApiConfig, AppConfig as ApplicationConfig, OktaConfig } from '../core';

export class Environment {
  /*********************Properties*********************/
  get appConfig(): ApplicationConfig {
    return this.applicationConfiguration;
  }

  set appConfig(config: ApplicationConfig) {
    this.applicationConfiguration = config;
  }

  get apiConfig(): ApiConfig {
    return this.apiConfiguration;
  }

  set apiConfig(config: ApiConfig) {
    this.apiConfiguration = config;
  }

  get oktaConfig(): OktaConfig {
    return this.oktaConfiguration;
  }

  set oktaConfig(config: OktaConfig) {
    this.oktaConfiguration = config;
  }

  private static instance: Environment;

  private applicationConfiguration: ApplicationConfig = {
    apiKey: '',
    nutracApiKey: '',
    apiTimeOut: '60',
    production: false,
    app: {
      comingSoon: false,
      down: false,
      hasError: false,
      loaded: false,
      message: null,
      restrictUserAccess: true
    },
    logger: {
      serverLog: false,
      serverLogLevel: LogLevel.ERROR,
      logLevel: LogLevel.LOG,
    },
    apigeeTokenEndpoint: '',
    oktaIdmLoginUrl: '',
    nuctrac340BEmailInquires:'',
    wdNrcGuideUrl:''
  };

  private apiConfiguration: ApiConfig = {
    //auth: '',
    //login: '',
    //logger: '',
    //user: '',
    //nutracConfig: '',
    bin:'',
    config:'',
    hp:'',
    inventory:'',
    nucbotDialog:'',
    nucbotProjectID:'',
    nucbotToken:'',
    order:'',
    patient:'',
    report:'',
    util:''
  };

  private oktaConfiguration: OktaConfig = {
    clientId: '',
    issuer: '',
    scope: '',
    oktaTokenEndpoint: '',
  };
  /*********************Properties*********************/

  /*********************Constructor*********************/
  private constructor() {}
  /*********************Constructor*********************/

  /*********************Methods*********************/

  static getInstance() {
    if (!Environment.instance) {
      Environment.instance = new Environment();
    }

    return Environment.instance;
  }

  /*********************Methods*********************/
}
